"use client";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { Separator } from "@akashnetwork/ui/components";
import { cn } from "@akashnetwork/ui/utils";

import type { ISidebarGroupMenu } from "@src/types";
import { SidebarRouteButton } from "./SidebarRouteButton";

type Props = {
  children?: ReactNode;
  hasDivider?: boolean;
  isNavOpen: boolean;
  group: ISidebarGroupMenu;
};

export const SidebarHoveredGroupMenu: React.FunctionComponent<Props> = ({ group, hasDivider = true, isNavOpen }) => {
  const intl = useIntl();
  return (
    <div className="p-1">
      {hasDivider && <Separator className="mb-2" />}

      <nav
        className={cn("flex flex-1 flex-col", { ["items-center"]: !isNavOpen })}
        aria-label={intl.formatMessage({ id: "layout.sidebarhoveredgroupmenu.arialabel", defaultMessage: "Sidebar" })}
      >
        <ul role="list" className="w-full space-y-1">
          {!!group.title && isNavOpen && (
            <li>
              <span className="text-sm font-light">{group.title}</span>
            </li>
          )}

          {group.routes.map((route, i) => {
            return route.customComponent ? (
              <li key={`${i}-${route.title}`}>{route.customComponent}</li>
            ) : (
              <SidebarRouteButton key={`${i}-${route.title}`} route={route} isHovered />
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
